import { Env } from '@/env';

/* eslint-disable no-console */
class Logger {
  LEVEL_DEBUG = 'debug';

  LEVEL_INFO = 'info';

  LEVEL_WARNING = 'warning';

  LEVEL_ERROR = 'error';

  /**
   * A window.console wrapper
   * @param {string} message
   * @param {string} level
   * @private
   */
  _log(message, level = null) {
    switch (level) {
      case this.LEVEL_DEBUG:
        console.debug(message);
        break;
      case this.LEVEL_INFO:
        console.info(message);
        break;
      case this.LEVEL_WARNING:
        console.warn(message);
        break;
      case this.LEVEL_ERROR:
        console.error(message);
        break;
      default:
        console.log(message);
    }
    // console.trace();
  }

  /**
   * window.console messages for development and QA environments
   * @param {string|Error} message
   * @param {string} level
   */
  log(message, level = null) {
    if (Env.isDevelopment() || Env.isQA()) {
      this._log(message instanceof Error ? message.message : message, level);
    }
  }
}

export default new Logger();
